import { IconWrapper } from '../runtime';
export default IconWrapper('idle', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M12.75 7.24976H13.25C14.0784 7.24976 15 7.92133 15 8.74976V9.99976C15 10.8282 14.0784 11.4998 13.25 11.4998H12.75M2.75 0.999756V2.99976M7 0.999756V2.99976M11.25 0.999756V2.99976M4.5 14.4998H9.5C11.1569 14.4998 12.5 13.1566 12.5 11.4998V6.99976C12.5 6.17133 11.8284 5.49976 11 5.49976H3C2.17157 5.49976 1.5 6.17133 1.5 6.99976V11.4998C1.5 13.1566 2.84315 14.4998 4.5 14.4998Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});